import type {MaterialStorage} from '@domain/material-storage'
import {CurrentMaterialStoragesQueryKey, useDeleteMaterialStorage} from '@domain/material-storage'
import {useNotification} from '@hconnect/uikit'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../common/providers/QueryProvider'
import type {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

export const useDeleteStorage = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useDeleteMaterialStorage({
    onError: (error) => {
      const data = (error as AxiosError<ErrorResponse>).response?.data
      notifyIfErrorMessage(data?.message, raiseError, notify)
    },
    onSuccess: (data, variables) => {
      notify('success', t('success.deleteStorage'))
      const prevStorages = settingsQueryClient.getQueryData<MaterialStorage[]>([
        CurrentMaterialStoragesQueryKey,
        variables.plantCode
      ])
      if (!prevStorages) {
        throw new Error('Bug: storage query should be loaded to add a new storage')
      }
      settingsQueryClient.setQueryData(
        [CurrentMaterialStoragesQueryKey, variables.plantCode],
        prevStorages.filter((storage) => storage.id !== variables.id)
      )
    }
  })
}
